var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ele-icon-picker" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "70%",
            "close-on-click-modal": false,
            "append-to-body": true,
            title: "选择图标",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "icon-grid" },
            _vm._l(_vm.filteredIcons, function (name) {
              return _c(
                "div",
                {
                  key: name,
                  staticClass: "icon-item",
                  class: { active: name === _vm.current },
                  on: {
                    click: function ($event) {
                      return _vm.selectIcon(name)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "icon", class: name }),
                  _c("div", { staticClass: "name", attrs: { title: name } }, [
                    _vm._v(_vm._s(name)),
                  ]),
                ]
              )
            }),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.cancel } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    disabled: !_vm.current,
                  },
                  on: { click: _vm.confirm },
                },
                [_vm._v(" 确 定 ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }